module.exports = __webpack_public_path__ + "media/images/vector-96@2x-3b56863479d1c294f7300b20a406daf1.png";